import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initSentry } from './lib/sentry';
import { initPostHog } from './lib/posthog';
import { isPreviewEnvironment } from './lib/envUtils';
import './index.css';

/**
 * Agrega meta tag noindex si estamos en preview
 * para evitar indexación por motores de búsqueda
 */
function addNoIndexIfPreview() {
  if (!isPreviewEnvironment()) {
    return;
  }
  
  // Verificar si ya existe el meta tag
  let robotsMeta = document.querySelector('meta[name="robots"]');
  
  if (!robotsMeta) {
    // Crear nuevo meta tag
    robotsMeta = document.createElement('meta');
    robotsMeta.setAttribute('name', 'robots');
    document.head.appendChild(robotsMeta);
  }
  
  // Establecer noindex, nofollow para preview
  robotsMeta.setAttribute('content', 'noindex, nofollow');
  
  console.log('🔒 Preview environment detected: noindex, nofollow meta tag added');
}

// Agregar noindex si estamos en preview (antes de renderizar)
addNoIndexIfPreview();

// Inicializar Sentry antes de renderizar la app
initSentry();

// Inicializar PostHog para analytics
initPostHog();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);